import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

interface Props extends SvgProps {
  add?: boolean;
}

const PasswordIcon = (props: Props) => <Svg
  width='24'
  height='24'
  viewBox='0 0 24 24'
  fill='none'
  {...props}
>
  <Path
    fillRule='evenodd'
    clipRule='evenodd'
    d='M15.5 7.5V6C15.5 4.067 13.933 2.5 12 2.5C10.067 2.5 8.5 4.067 8.5 6V7.5H15.5ZM12 1C9.23858 1 7 3.23858 7 6V9H17V6C17 3.23858 14.7614 1 12 1Z'
    fill={props.color ?? '#3379BD'}
  />
  <Path
    fillRule='evenodd'
    clipRule='evenodd'
    d='M18 9H6C5.17157 9 4.5 9.67157 4.5 10.5V19.5C4.5 20.3284 5.17157 21 6 21H18C18.8284 21 19.5 20.3284 19.5 19.5V10.5C19.5 9.67157 18.8284 9 18 9ZM6 7.5C4.34315 7.5 3 8.84315 3 10.5V19.5C3 21.1569 4.34315 22.5 6 22.5H18C19.6569 22.5 21 21.1569 21 19.5V10.5C21 8.84315 19.6569 7.5 18 7.5H6Z'
    fill={props.color ?? '#3379BD'}
  />
  <Path
    d='M11 16.5C10.4477 16.5 10 16.0523 10 15.5C10 14.9477 10.4477 14.5 11 14.5H13C13.5523 14.5 14 14.9477 14 15.5C14 16.0523 13.5523 16.5 13 16.5H11Z'
    fill={props.color ?? '#3379BD'}
  />
</Svg>;

export default PasswordIcon;
